(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  const Carousel = global.NewHomeSource.Carousel;

  if (!Carousel.PercentOfView) {
    return;
  }

  class ScrollBounds {
    /**
     * Initializes a new instance of the class.
     * Sets the initial state to null.
     */
    constructor() {
      this.state = null;
      this.snapBackDuration = 25;
      this.pullBackThresholdValue = 10;
      this.edgeOffsetToleranceValue = 50;
      this.frictionLimitMin = 0.1;
      this.frictionLimitMax = 0.99;
    }

    /**
     * Initializes the carousel scroll bounds with the provided state.
     * Sets up view size, pull back threshold, edge offset tolerance, friction limit, and base friction.
     *
     * @param {Object} state - The state object containing configuration for the carousel.
     * @returns {this} The current instance for chaining.
     */
    initialize(state) {
      this.state = state;
      const percentOfView = new Carousel.PercentOfView();
      percentOfView.setViewSize(this.state.get('viewSize'));
      this.pullBackThreshold = percentOfView.measure(this.pullBackThresholdValue);
      this.edgeOffsetTolerance = percentOfView.measure(this.edgeOffsetToleranceValue);
      this.frictionLimit = new Carousel.Limit();
      this.frictionLimit.initialize(this.frictionLimitMin, this.frictionLimitMax);
      this.baseFriction = this.state.get('friction');

      return this;
    }

    /**
     * Determines whether the scroll position should be constrained based on the current state.
     *
     * Checks if the scroll limit has been reached for both the target and current location.
     * Returns true if both have reached any scroll limit, otherwise false.
     *
     * @returns {boolean} True if the scroll should be constrained, false otherwise.
     */
    shouldConstrain() {
      const limit = this.state.get('scrollLimit');
      const location = this.state.get('location');
      const target = this.state.get('target');

      if (!limit.reachedAny(target.get())) {
        return false;
      }

      if (!limit.reachedAny(location.get())) {
        return false;
      }

      return true;
    }

    /**
     * Constrains the carousel's scroll position within defined bounds, applying friction when the edge is approached.
     * Adjusts the target scroll position based on proximity to the edge and user interaction.
     *
     * @param {boolean} pointerDown - Indicates whether the pointer (e.g., mouse or touch) is currently pressed down.
     * @returns {void}
     */
    constrain(pointerDown) {
      const limit = this.state.get('scrollLimit');
      const location = this.state.get('location');
      const target = this.state.get('target');
      if (!this.shouldConstrain()) {
        return;
      }

      const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
      const diffToEdge = Math.abs(limit[edge] - location.get());
      const diffToTarget = target.get() - location.get();
      const friction = this.frictionLimit.constrain(diffToEdge / this.edgeOffsetTolerance);
      target.subtract(diffToTarget * friction);
      if (!pointerDown && Math.abs(diffToTarget) < this.pullBackThreshold) {
        target.set(limit.constrain(target.get()));
        this.state.setDuration(this.snapBackDuration);
        this.state.setFriction(this.baseFriction);
      }
    }
  }

  global.NewHomeSource.Carousel.ScrollBounds = ScrollBounds;
}(window));
